import React from "react"
import { Container, Row, Col } from "react-bootstrap"
import Fundraise from "../images/fundraise_pic.png"
import OurTeam from "../images/our_team_pic.png"
import Events from "../images/events_pic.png"
import { Link } from "gatsby"
import { useTranslation } from "react-i18next"

export default function KnowUsSection(params) {
  const { t } = useTranslation()
  return (
    <section className="know-us-area bg-light pb-50">
      <Container>
        <Row className="justify-content-end">
          <Col sm={6} className="text-right">
            <h1 className="title-section">{t("knowUs")}</h1>
            <h5 className="sub-title">{t("knowUsSub")}</h5>
          </Col>
        </Row>
        <Row className="justify-content-center text-center">
          <Col sm={4}>
            <Link to="/the-people">
              <img src={OurTeam} alt="our-team" loading="lazy" />
            </Link>
            <h5 className="sub-title-mobile">{t("ourTeam")}</h5>
          </Col>
          <Col sm={4}>
            <img src={Fundraise} alt="fundraise" loading="lazy" />
            <h5 className="sub-title-mobile">{t("fund")}</h5>
          </Col>
          <Col sm={4}>
            <img src={Events} alt="events" loading="lazy" />
            <h5 className="sub-title-mobile">{t("events")}</h5>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
